import React, { useEffect, useRef } from "react";
import { AuthUser } from "aws-amplify/auth";
import appVersion from "../app-version.json";
import {
  WAWI_PM_APP_ID,
  hasRecordedLoginThisSession,
  markLoginRecordedThisSession,
  recordUserEvent,
} from "../core/userActivity";

// Records the successful login at most once per mount and once per browser
// session (a page refresh must not re-send it). Fire-and-forget: telemetry
// must never block or break the login UX.
const RecordLoginOnAuth: React.FC<{ user: AuthUser }> = ({ user }) => {
  const hasRecordedLoginRef = useRef(false);

  useEffect(() => {
    if (!hasRecordedLoginRef.current && !hasRecordedLoginThisSession(user.userId)) {
      hasRecordedLoginRef.current = true;
      markLoginRecordedThisSession(user.userId);
      void recordUserEvent({
        type: "LOGIN",
        appId: WAWI_PM_APP_ID,
        appVersion: appVersion.version,
      });
    }
  }, [user.userId]);

  return null;
};

export default RecordLoginOnAuth;
